import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";

export const setAccountOptionsMutator: (mailboxInfos: MailboxInfo[]) => void = mutatorAction("setAccountOptionsMutator", (mailboxInfos: MailboxInfo[]): void => {
    const store = getStore();
    store.accountOptions = mailboxInfos;
});

export const setCurrentAccountMutator: (account: MailboxInfo) => void = mutatorAction("setCurrentAccountMutator", (account: MailboxInfo): void => {
    getStore().currentAccount = account;
});

export const resetCopilotAccountPickerDialogStoreMutator: () => void = mutatorAction("resetCopilotAccountPickerDialogStoreMutator", (): void => {
    const store = getStore();
    store.currentAccount = null;
    store.accountOptions = [];
});
